import { flexContainer } from "../baseStyles";

const eventsListStyle = (theme) => ({
	flexContainer: {
		...flexContainer,
	},
	button: {
		margin: "auto",
	},
});

export default eventsListStyle;
